export type Urgency =
  | 'urgent'
  | 'needs_attention'
  | 'routine'
  | 'informational';

export type Visibility = 'private' | 'shared';

export type Source = 'user' | 'camera';

export type GroupingKey = 'default' | 'urgency' | 'status' | 'visibility';

export type FilterKey =
  | 'urgency'
  | 'department'
  | 'people'
  | 'tags'
  | 'visibility'
  | 'source'
  | 'signal';

export interface PersonOption {
  id: string;
  name: string;
  role: string;
  initials: string;
}

export interface DepartmentOption {
  id: string;
  name: string;
}

export interface SignalOption {
  id: string;
  name: string;
}

export interface TagOption {
  id: string;
  name: string;
}

export interface FilterValues {
  urgency: Urgency | null;
  department: string | null;
  person: string | null;
  tag: string | null;
  visibility: Visibility | null;
  source: Source | null;
  signal: string | null;
}

export interface FilterOptions {
  departments: DepartmentOption[];
  people: PersonOption[];
  tags: TagOption[];
  signals: SignalOption[];
}

export const EMPTY_FILTERS: FilterValues = {
  urgency: null,
  department: null,
  person: null,
  tag: null,
  visibility: null,
  source: null,
  signal: null,
};
